import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { HomeIcon, CalendarIcon, SettingsIcon } from 'lucide-react';
export function LoggedInNav() {
  const location = useLocation();
  const isActive = (path: string) => {
    return location.pathname === path;
  };
  return <nav className="w-full bg-[#1A2331] border-b border-[#F5F7FA] border-opacity-10" data-id="element-339">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-340">
        <div className="flex items-center justify-between h-16" data-id="element-341">
          <div className="flex items-center" data-id="element-342">
            <div className="flex-shrink-0" data-id="element-343">
              <div className="flex items-center" data-id="element-344">
                <Link to="/dashboard" data-id="element-345">
                  <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/ov4W5y1TwYUNeHUCdRzqBe/Prepz.io_Logo_2.png" alt="Prepz.io Logo" className="h-24 w-auto" data-id="element-346" />
                </Link>
              </div>
            </div>
            <div className="hidden md:block" data-id="element-347">
              <div className="ml-10 flex items-baseline space-x-4" data-id="element-348">
                <Link to="/dashboard" className={`px-3 py-2 rounded-md text-sm font-medium flex items-center ${isActive('/dashboard') ? 'bg-[#C8F169] bg-opacity-20 text-[#C8F169]' : 'text-[#F5F7FA] text-opacity-70 hover:text-opacity-100'}`} data-id="element-349">
                  <HomeIcon className="mr-2 h-4 w-4" data-id="element-350" />
                  Dashboard
                </Link>
                <Link to="/prepcentre" className={`px-3 py-2 rounded-md text-sm font-medium flex items-center ${isActive('/prepcentre') ? 'bg-[#C8F169] bg-opacity-20 text-[#C8F169]' : 'text-[#F5F7FA] text-opacity-70 hover:text-opacity-100'}`} data-id="element-351">
                  <CalendarIcon className="mr-2 h-4 w-4" data-id="element-352" />
                  Prep Centre
                </Link>
                <Link to="/settings" className={`px-3 py-2 rounded-md text-sm font-medium flex items-center ${isActive('/settings') ? 'bg-[#C8F169] bg-opacity-20 text-[#C8F169]' : 'text-[#F5F7FA] text-opacity-70 hover:text-opacity-100'}`} data-id="element-353">
                  <SettingsIcon className="mr-2 h-4 w-4" data-id="element-354" />
                  Command HQ
                </Link>
              </div>
            </div>
          </div>
          <div className="flex items-center" data-id="element-355">
            <div className="ml-4 flex items-center md:ml-6" data-id="element-356">
              <div className="relative" data-id="element-357">
                <div className="flex items-center" data-id="element-358">
                  <div className="h-8 w-8 rounded-full bg-[#C8F169] flex items-center justify-center text-[#1E2A38] font-bold" data-id="element-359">
                    JS
                  </div>
                  <span className="ml-2 text-sm font-medium hidden md:block" data-id="element-360">
                    John Smith
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </nav>;
}